<template>
  <section>
    <div class="member-search__toggle">
      <PDrawerToggle />
    </div>

    <PDrawerHeaderFilters search-only />

    <HTextfield
      v-model:value="channelId"
      placeholder="Buscar por ID do canal"
      icon="icSearch"
      class="member-search__channel"
      @keyup.enter="handleSearchChannel"
    />

    <CEmptyState
      icon="plan"
      size="xsmall"
      title="Buscar por membro ou canal"
      message="Utilize para localizar as informações de um membro ou buscar por um canal específico"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex'

import { HTextfield } from '@/components/shared/atoms'

import { CEmptyState } from '../../atoms'
import PDrawerToggle from '../../atoms/drawer/PDrawerToggle.vue'
import PDrawerHeaderFilters from './PDrawerHeaderFilters.vue'

export default {
  components: {
    PDrawerHeaderFilters,
    CEmptyState,
    PDrawerToggle,
    HTextfield
  },
  data() {
    return {
      channelId: null
    }
  },
  computed: {
    ...mapState('channel/drawer', ['currentFilters'])
  },
  watch: {
    'currentFilters.personId'() {
      if (!this.currentFilters.personId) return
      if (
        this.currentFilters.personId === this.$route.params.personId &&
        !this.$route.query.channelId
      )
        return
      this.$store.commit('ui/channel/resetChannelsUI')
      this.$router.push(`/member/${this.currentFilters.personId}/pillars`)
    }
  },
  methods: {
    async handleSearchChannel() {
      if (this.$route.query.channelId === this.channelId || !this.channelId) {
        return
      }
      const channel = await this.$store.dispatch('channel/fetchChannelById', {
        channelId: this.channelId
      })
      if (channel) {
        const routerPath = `/member/${channel.personId}/pillars?channelId=${this.channelId}`
        await this.$router.push(routerPath)
        this.channelId = null
      }
    }
  }
}
</script>
<style lang="scss">
.member-search__toggle {
  padding-top: var(--gl-spacing-04);
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.member-search__channel {
  margin-top: var(--gl-spacing-04);
  margin-bottom: var(--gl-spacing-04);
}
</style>
